import { render, staticRenderFns } from "./AskAdvice.vue?vue&type=template&id=7646b73e&scoped=true&"
import script from "./AskAdvice.vue?vue&type=script&lang=js&"
export * from "./AskAdvice.vue?vue&type=script&lang=js&"
import style0 from "./AskAdvice.vue?vue&type=style&index=0&id=7646b73e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7646b73e",
  null
  
)

export default component.exports